<template lang="pug">
  .events_popup
    .popup__inner
      .popup__inner-left
        img(:src="data.PICTURE" alt="kvartirnik-rosatoma")
      .popup__inner-right(:style="{backgroundImage: 'url(' + data.BACKGROUND + ')'}")
        .popup__inner-title {{ data.NAME }}
        clocks(:initialTimestamp = "data.TIMESTAMP")
        a.popup__inner-link(@click="closePopup" :href="data.CODE" target="_blank") Подробнее
        .popup__inner-close(@click="closePopup")
          .popup__inner-close-line
          .popup__inner-close-line

</template>

<script>

  import Clocks from "@/components/other/Clocks/";

  export default {
    name: "EventsPopup",
    components: {Clocks},
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    data: () => ({}),
    methods: {
      async markPopupAsReaded() {
        try {
          let {data} = await this.axios.get('?ACTION=setViewedPopup&PID=' + this.data.ID);
          if (data.STATUS === 'ok') {
            console.log("Popup markered as viewed");
          }
        } catch (e) {
          console.log(e);
        }
      },
      closePopup() {
        this.markPopupAsReaded()
        this.$emit('closePopup')
      }
    }
  }
</script>


<style lang="scss">
  @import "@/assets/scss/_functions.scss";
  @import "@/assets/scss/_variables.scss";
  @import "@/assets/scss/_mixins.scss";

  .events_popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    overflow: auto;

    .popup__inner {
      background-color: $blue1;
      width: 72.5rem;
      height: 25.5rem;
      display: flex;
    }

    .popup__inner-left {
      width: 50%;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .popup__inner-right {
      width: 50%;
      position: relative;
      padding: 2.5rem;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      align-items: center;
    }

    .popup__inner-title {
      font-size: 2.625rem;
      letter-spacing: -0.4px;
      text-align: center;
    }

    .popup__inner-event-title {
      margin-top: 0.4rem;
    }

    .flipClock {
      max-width: 314px;
    }

    .popup__inner-link {
      color: white;
      font-size: 1.25rem;
      position: relative;
      display: inline-flex;
      padding: 1rem 1.9rem;
      cursor: pointer;
      white-space: nowrap;
      background: center / 100% 100% no-repeat url("~@/assets/img/popups/link-bg.png");

      /*&::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        border: 1px solid #fff;
        transform: skewX(-18deg);
        box-shadow: 0 0 1.5rem hsla(0,0%,100%,.4), inset 0 0 1rem hsla(0,0%,100%,.27);
      }*/
    }

    .popup__inner-close {
      position: absolute;
      right: 1rem;
      top: 2.5rem;
      font-size: 0;

      .popup__inner-close-line {
        width: 2.5rem;
        height: 2px;
        background-color: white;

        &:nth-of-type(1) {
          transform: rotate(45deg);
        }

        &:nth-of-type(2) {
          transform: rotate(-45deg) translateY(-2px);
        }
      }
    }

    @include razr960 {
      .popup__inner {
        flex-direction: column;
        height: auto;
        width: 32.5rem;
      }

      .popup__inner-left, .popup__inner-right {
        width: 100%;
      }
    }

    @include razr767P {
      align-items: flex-start;
      .popup__inner {
        min-height: 100%;
        /*overflow: auto;*/
      }

      .popup__inner-left {
        flex-grow: 0;

        img {
          height: auto;
        }
      }
      .popup__inner-right {
        flex-grow: 1;
        padding: 4.5rem 2.5rem 2.5rem;
        background-size: 100% 100%;
      }
    }
  }
</style>
